
export class SpValidationService {
    // True = valid
    public static validateMimeTypes(type: string, allowedMimeTypes: string[]): boolean {
        let allowed = false;
        for (const mimeType of allowedMimeTypes) {
            if (new RegExp(mimeType.replace('*', '[^\\/,]+')).test(type))
                allowed = true;
        }
        return allowed;
    }

    // True = valid
    public static validateFileSize(file: Blob, allowedSizeInBytes: number): boolean {
        return file.size <= allowedSizeInBytes;
    }
}